import _ from 'lodash';
import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {wardsList} from '../store/reducers/ward';
import {trudWardsDict} from '../store/reducers/dicts';

export default function useWardTrudMatrix() {
    const wardList = useSelector(wardsList);
    const trudWardList = useSelector(trudWardsDict);

    const [wards, setWards] = useState([]);
    const [wardsLoading, setWardsLoading] = useState(false);

    useEffect(() => {
        setWardsLoading(true);
        const onlyActive = _.filter(wardList, w => w.active);
        if (!_.isEmpty(onlyActive)) {
            const wardList = [];
            const wardsId = new Set();
            let wardName = {};

            onlyActive.map(oa => {
                wardsId.add(...oa.wardsId);
                if (oa.wardsId?.length === 1) {
                    wardName = {
                        ...wardName,
                        [oa.wardsId]: oa.name,
                    }
                }
            });

            wardsId.forEach(key => {
                const find = _.find(trudWardList, {wardCode: key});
                if (find) {
                    wardList.push({
                        id: find?.__id,
                        ward: find?.wardCode,
                        description: _.startCase(find?.wardName?.toLowerCase()),
                        name: wardName[find?.wardCode],
                    });
                }
            });
            setWards(wardList);
        }
        setWardsLoading(false);
    }, [wardList, trudWardList]);

    return [wards, wardsLoading];
}